import React from "react";
import Modal from "react-bootstrap/Modal";
const GoogleDocViewer = ({ fileURL, show, setShow, title }) => {
  //const googleViewerURL = `https://docs.google.com/viewer?url=${fileURL}&embedded=true`;
  const googleViewerURL = `https://docs.google.com/viewer?url=https://www.africau.edu/images/default/sample.pdf&embedded=true`;

  return (
    <Modal show={show} fullscreen onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <div style={{ width: "100%", height: "600px" }}>
        <iframe
          title='Google Document Viewer'
          src={googleViewerURL}
          frameBorder='0'
          style={{ width: "100%", height: "100%" }}
          x-frame
        />
      </div>
    </Modal>
  );
};

export default GoogleDocViewer;
